import { Invitation } from '@nemuru-eng/js-api-client';

import { BorrowerInvitationEditDialog } from '@/components/modules/KYC/KYCLoan/shared/BorrowerInvitationSection/components/BorrowerInvitationEditDialog';
import { BorrowerInvitationForm } from '@/components/modules/KYC/KYCLoan/shared/BorrowerInvitationSection/components/BorrowerInvitationForm';
import { FieldVariant } from '@/components/shared/components/NewContextForms/types/FieldVariant';
import { PendingDataWarning } from '@/components/shared/components/PendingDataWarning';
import { SubSectionWrapper } from '@/components/shared/components/SubSectionWrapper';
import { useDialog } from '@/components/shared/hooks/useDialog';
import { PendingDataType } from '@/config/types';
import { usePageContext } from '@/contexts/PageContext/PageContext';

interface BorrowerInvitationSectionProps {
  borrowerInvitation: Invitation | null;
  editModeAllowed?: boolean;
}

export const BorrowerInvitationSection = ({
  borrowerInvitation,
  editModeAllowed = false,
}: BorrowerInvitationSectionProps) => {
  const { opened, toggleDialog, setOpened } = useDialog();
  const {
    state: { applicationParticipant },
  } = usePageContext();
  const toggleEditModeDialog = editModeAllowed && borrowerInvitation ? toggleDialog : undefined;

  if (!borrowerInvitation) return null;

  return (
    <SubSectionWrapper title={'BORROWER_INVITATION'} toggleEditModeDialog={toggleEditModeDialog}>
      <BorrowerInvitationForm
        fieldVariant={FieldVariant.dataRow}
        borrowerInvitation={borrowerInvitation}
        participantRole={applicationParticipant.role}
      />
      {borrowerInvitation ? (
        <BorrowerInvitationEditDialog
          borrowerInvitation={borrowerInvitation}
          opened={opened}
          setOpened={setOpened}
          toggleDialog={toggleDialog}
        />
      ) : (
        <PendingDataWarning type={PendingDataType.BORROWER_ONBOARDING} />
      )}
    </SubSectionWrapper>
  );
};
